// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "大学物理（下)",
      "tec": "李海丽",
      "week": "1-9,11-15周",
      "add": "教学楼A座225电力"
    },
    {
      "sub": "概率论与数理统计",
      "tec": "耿爱成",
      "week": "1-8,11-18双周",
      "add": "教学楼C座215教务"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-6,8,11-15周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "创造性思维与创新方法",
      "tec": "姜河",
      "week": "1-8,11-18周",
      "add": "教学楼C座304教务"
    },
    0
  ],
  "2": [
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25动核新2-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼E座418法律"
      },
      {
        "sub": "25动核新2-3",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25动核新2-2",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "教学楼B座121自控"
      },
      {
        "sub": "25动核新2-4",
        "tec": "贺静",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25动核新1-1",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "教学楼B座319能动"
      },
      {
        "sub": "25动核新1-4",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25动核新1-2",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "教学楼B座220能动"
      }
    ],
    {
      "sub": "电路（二）",
      "tec": "姚宗君",
      "week": "1-8,11-18周",
      "add": "教学楼D座124新能"
    },
    {
      "sub": "科技文献检索",
      "tec": "白波",
      "week": "1-4周",
      "add": "教学楼D座120新能"
    },
    [
      {
        "sub": "工程力学",
        "tec": "周金华",
        "week": "1-8周",
        "add": "教学楼D座120新能"
      },
      {
        "sub": "就业创业指导",
        "tec": "赵明明王梓",
        "week": "11-15周",
        "add": "教学楼D座122新能"
      }
    ],
    0
  ],
  "3": [
    {
      "sub": "马克思主义基本原理",
      "tec": "马继强",
      "week": "1-6,8,11-15周",
      "add": "教学楼B座425能动"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "商晶",
      "week": "1-8,11-18周",
      "add": "教学楼D座125经管"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "工程制图",
      "tec": "赵宇",
      "week": "1-8,11-18周",
      "add": "教学楼A座319机械"
    },
    {
      "sub": "大学物理（下)",
      "tec": "李海丽",
      "week": "1-9,11-15周",
      "add": "教学楼A座225电力"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "足球",
        "tec": "张慧",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "健美操",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女排",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "贾思敏",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男篮",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "搏击",
        "tec": "李庆",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "轮滑",
        "tec": "郝策",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男网",
        "tec": "李灏",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "男乒",
        "tec": "李莉",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女羽",
        "tec": "陈迪",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女乒",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "足球"
      },
      {
        "sub": "女网",
        "tec": "李罡",
        "week": "1-18周",
        "add": "足球"
      }
    ],
    {
      "sub": "电路（二）",
      "tec": "姚宗君",
      "week": "1,3,5,7,11,13,15,17周",
      "add": "教学楼D座124新能"
    },
    {
      "sub": "形势与政策",
      "tec": "祝嘉悦",
      "week": "1-4周",
      "add": "教学楼C座210教务"
    }
  ],
  "5": [
    {
      "sub": "概率论与数理统计",
      "tec": "耿爱成",
      "week": "1-8,11-18周",
      "add": "教学楼C座215教务"
    },
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25动核新2-4",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25动核新2-2",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "25动核新1-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25动核新1-3",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25动核新1-2",
        "tec": "贺静",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25动核新1-1",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼E座418法律"
      },
      {
        "sub": "25动核新2-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      }
    ],
    {
      "sub": "工程力学",
      "tec": "周金华",
      "week": "1-8周",
      "add": "教学楼A座317机械"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
